import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

const BTButtonWithLoader = ({
  isLoading = false,
  isDisabled = false,
  showLoadingText = false,
  title,
  loadingTitle = "Loading...",
  type = "submit",
  className = "",
  onClick = () => {},
}) => {
  return (
    // <BTButtonCSSClassCom>
    <Button
      type={type}
      variant="primary"
      className={`text-center ${className}`.trim()}
      disabled={isLoading || isDisabled}
      onClick={onClick}
      onMouseDown={(e) => e.preventDefault()}
      aria-busy={isLoading}
    >
      {isLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm pr-1"
            role="status"
            aria-hidden="true"
          ></span>
          {!showLoadingText && <span className="sr-only">{loadingTitle}</span>}
        </>
      ) : (
        title
      )}
    </Button>
    // </BTButtonCSSClassCom>
  );
};

BTButtonWithLoader.propTypes = {
  showLoadingText: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  loadingTitle: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default BTButtonWithLoader;
